define([
    "./monitoringFollowupOverviewModule",
    "./monitoringFollowupOverviewController",
    "./monitoringFollowupOverview.less"
], function () {
});
